import { useEffect, useState } from "react";
import api from "@/lib/api";
import AdminProductDetail from "@/pages/AdminProductDetail";

const SUBS = [["pending", "Pending"], ["failed", "Failed"], ["passed", "Passed"]];

export default function AdminInspectionQueue() {
  const [data, setData] = useState({ pending: [], failed: [], passed: [] });
  const [sub, setSub] = useState("pending");
  const [detailId, setDetailId] = useState(null);

  const load = async () => { try { setData((await api.get("/admin/inspection-queue")).data); } catch { /* noop */ } };
  useEffect(() => { load(); }, []);
  const rows = data[sub] || [];

  return (
    <div>
      <h2 className="font-serif text-4xl tracking-tighter">Inspection Queue.</h2>
      <p className="text-muted-foreground mt-1">Physical inspection — the three Spotters sign off before a product goes live.</p>

      <div className="flex gap-5 border-b border-foreground/20 mt-6 mb-6 font-mono text-[11px] uppercase tracking-widest">
        {SUBS.map(([k, l]) => (
          <button key={k} onClick={() => setSub(k)} className={`py-2 border-b-2 ${sub === k ? "border-[hsl(var(--accent))] text-[hsl(var(--accent))]" : "border-transparent text-muted-foreground hover:text-foreground"}`}>
            {l} ({(data[k] || []).length})
          </button>
        ))}
      </div>

      {rows.length === 0 ? (
        <p className="font-serif text-2xl text-muted-foreground">{sub === "pending" ? "Nothing waiting to be inspected. 🎉" : `No ${sub} inspections.`}</p>
      ) : (
        <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead><tr className="border-b border-foreground font-mono text-[10px] uppercase tracking-widest"><th className="text-left py-2">Product</th><th className="text-left">Vendor</th><th className="text-left">Result</th><th></th></tr></thead>
          <tbody>
            {rows.map((p) => (
              <tr key={p.id} className="border-b border-foreground/15">
                <td className="py-3">
                  <button onClick={() => setDetailId(p.id)} className="flex items-center gap-3 text-left group">
                    <div className="w-10 h-10 bg-secondary shrink-0 overflow-hidden">{p.images?.[0] && <img src={p.images[0]} alt="" className="w-full h-full object-cover" />}</div>
                    <span className="font-serif group-hover:text-[hsl(var(--accent))] transition-colors">{p.title}</span>
                  </button>
                </td>
                <td className="text-[11px]">{p.vendor_name}</td>
                <td className="font-mono text-xs">
                  {p.spotted_certificate ? (p.spotted_certificate.passed ? <span className="text-[hsl(var(--accent))]">PASSED</span> : <span className="text-destructive">FAILED</span>) : <span className="text-muted-foreground">AWAITING</span>}
                </td>
                <td className="text-right">
                  <button onClick={() => setDetailId(p.id)} className="bg-foreground text-background px-3 py-1.5 text-[10px] font-mono uppercase hover:bg-[hsl(var(--accent))]">{p.spotted_certificate ? "Re-inspect →" : "Inspect →"}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}

      {detailId && <AdminProductDetail productId={detailId} initialTab="Inspection" onClose={() => setDetailId(null)} onChanged={load} />}
    </div>
  );
}
